export const ROUTECAMP_TILES_ORIGIN = 'https://tiles.route.camp'
export const ROUTECAMP_STYLE_PATH = '/map/styles/routecamp/style.json'
export const ROUTECAMP_MAPTERHORN_TILE_TEMPLATE = `${ROUTECAMP_TILES_ORIGIN}/mapterhorn/planet/{z}/{x}/{y}.webp`

export function getRoutecampStyleUrl(
  styleUrlOverride?: string | null,
  cacheBuster?: string | null,
): string {
  const trimmedOverride = styleUrlOverride?.trim()
  if (trimmedOverride) {
    return trimmedOverride
  }

  const trimmedCacheBuster = cacheBuster?.trim()
  if (!trimmedCacheBuster) {
    return ROUTECAMP_STYLE_PATH
  }

  return `${ROUTECAMP_STYLE_PATH}?v=${encodeURIComponent(trimmedCacheBuster)}`
}

export function getRoutecampMapterhornTileTemplate(): string {
  return ROUTECAMP_MAPTERHORN_TILE_TEMPLATE
}

// Custom URI scheme used inside the Tauri native webview to proxy tile requests through Rust so
// they carry a `Referer: https://route.camp` header (browsers/webviews forbid setting `Referer`
// from JS). The Rust handler (`src-tauri/src/lib.rs`) forwards to `tiles.route.camp`.
export const ROUTECAMP_NATIVE_TILE_SCHEME = 'rctiles'

/**
 * Rewrite a `tiles.route.camp` URL to the native `rctiles` proxy scheme. Returns `null` for any URL
 * that does not target the tile origin so callers can leave it untouched.
 *
 * Tauri exposes custom schemes differently per platform: Android/Windows use
 * `http://<scheme>.localhost/...` while Apple/Linux use `<scheme>://localhost/...`.
 */
export function toNativeTileUrl(url: string, isAndroid: boolean): string | null {
  const prefix = `${ROUTECAMP_TILES_ORIGIN}/`
  if (!url.startsWith(prefix)) {
    return null
  }

  const rest = url.slice(ROUTECAMP_TILES_ORIGIN.length) // keeps the leading '/'
  const base = isAndroid
    ? `http://${ROUTECAMP_NATIVE_TILE_SCHEME}.localhost`
    : `${ROUTECAMP_NATIVE_TILE_SCHEME}://localhost`
  return `${base}${rest}`
}
